<template>
  <div class="container">
    <div class="block left intro">
      <div
        v-if="settings.step_1_description"
        v-html="settings.step_1_description"
      ></div>
      <p v-else>
        {{ $t('SelectProducts.info_text') }}
      </p>
    </div>

    <RoomSelector />

    <div class="products" :class="categoriesRight.length ? '' : 'two-col'">
      <LdsRippleWaiter v-if="!categoriesAreLoaded" />

      <div class="products-col">
        <CategoryCard
          v-for="category in categoriesLeft"
          :key="category.id"
          :category="category"
        />
      </div>
      <div class="products-col">
        <CategoryCard
          v-for="category in categoriesMiddle"
          :key="category.id"
          :category="category"
        />
      </div>
      <div class="products-col" v-if="categoriesRight.length">
        <CategoryCard
          v-for="category in categoriesRight"
          :key="category.id"
          :category="category"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import CategoryCard from '../products/CategoryCard';
import LdsRippleWaiter from '../utilities/LdsRippleWaiter';
import RoomSelector from '@/components/rooms/RoomSelector.vue';

export default {
  name: 'StepSwitchGear',
  components: {
    RoomSelector,
    LdsRippleWaiter,
    CategoryCard,
  },
  data() {
    return {
      categoriesAreLoaded: false,
    };
  },
  watch: {
    categories: {
      immediate: true,
      deep: true,
      handler(categories) {
        if (categories.length > 0) {
          this.categoriesAreLoaded = true;
        }
      },
    },
  },
  computed: {
    ...mapState('category-products', ['categories']),
    ...mapState('data', ['settings']),
    categoriesLeft() {
      return this.categories.filter((category) =>
        [0, 1].includes(category.column)
      );
    },
    categoriesMiddle() {
      return this.categories.filter((category) => category.column === 2);
    },
    categoriesRight() {
      return this.categories.filter((category) => category.column === 3);
    },
  },
};
</script>
